import { db } from '../firebase/config';
import { doc, setDoc, getDoc, collection, addDoc, Timestamp, query, where, getDocs } from 'firebase/firestore';

export interface AiUserData {
  userId: string;
  age?: number | null;
  occupation?: string | null;
  monthlyIncome?: number | null;
  riskProfile?: 'conservative' | 'moderate' | 'aggressive';
  investmentGoals?: string[];
  updatedAt: Date;
}

export interface AiUserDataHistory {
  userId: string;
  data: Partial<AiUserData>;
  updatedAt: Date;
}

// Salva ou atualiza dados para IA
export async function saveAiUserData(userId: string, data: Partial<AiUserData>) {
  const docRef = doc(db, 'aiUserData', userId);
  const now = new Date();
  await setDoc(docRef, { ...data, userId, updatedAt: now }, { merge: true });
  await addAiUserDataHistory(userId, data, now);
}

// Adiciona histórico de atualização
export async function addAiUserDataHistory(userId: string, data: Partial<AiUserData>, updatedAt: Date) {
  const historyRef = collection(db, 'aiUserDataHistory');
  await addDoc(historyRef, {
    userId,
    data,
    updatedAt: Timestamp.fromDate(updatedAt)
  });
}

// Recupera dados atuais
export async function getAiUserData(userId: string): Promise<AiUserData | null> {
  const docRef = doc(db, 'aiUserData', userId);
  const snap = await getDoc(docRef);
  if (!snap.exists()) return null;
  return snap.data() as AiUserData;
}

// Recupera histórico de atualizações
export async function getAiUserDataHistory(userId: string): Promise<AiUserDataHistory[]> {
  const historyRef = collection(db, 'aiUserDataHistory');
  const q = query(historyRef, where('userId', '==', userId));
  const snap = await getDocs(q);
  return snap.docs.map(doc => doc.data() as AiUserDataHistory);
}
